module.exports = __webpack_public_path__ + "images/services/jira-mark-gradient-blue.5f4b248c27fc25f5d2ec.svg";